import React from 'react'
import ReactDOM from 'react-dom'
import AerodynamicsCharts from '../src/javascripts/aerodynamics_charts';

const windOptions = {
  chart: {
    type: 'line',
  },
  title: {
    text: 'Wind Performance'
  },
  subtitle: {
     text: '.243 Caliber Claymore - 103 gr. (10 mph Wind)'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Muzzle Velocity (fps)'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Wind Deflection (MOA)'
    }
  },
  tooltip: {
    headerFormat: "{point.key:.0f} fps<br>",
    pointFormat: "{point.y:.1f} MOA @ {series.name}"
  },
  series: [{"name":"600.0 yards","data":[[2000.0,7.785540363078392],[2100.0,7.166833686269264],[2200.0,6.629254467868381],[2300.0,6.162498819000408],[2400.0,5.754106330255009],[2500.0,5.393104016268549],[2600.0,5.070899757798649],[2700.0,4.780824613167917],[2800.0,4.517421949787205],[2900.0,4.2761198235177345],[3000.0,4.053411468988454]]},{"name":"1000.0 yards","data":[[2000.0,14.200389027395877],[2100.0,13.643057735074752],[2200.0,13.020509381904155],[2300.0,12.352510538872007],[2400.0,11.65408234504347],[2500.0,10.941294860630762],[2600.0,10.242807273998608],[2700.0,9.598686310970976],[2800.0,9.016816299012342],[2900.0,8.49001245144997],[3000.0,8.010941047921563]]}]
};

const stabilityOptions = {
  chart: {
    type: 'line',
  },
  title: {
    text: 'Gyroscopic Stability'
  },
  subtitle: {
     text: '.243 Caliber Claymore - 103 gr.'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Muzzle Velocity (fps)'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Gyroscopic Stability Factor (Sg)'
    }
  },
  tooltip: {
    headerFormat: "{point.key:.0f} fps<br>",
    pointFormat: "SG: {point.y:.2f} @ {series.name}"
  },
  series: [{"name":"6.0 in/turn","data":[[2000.0,2.225519908958108],[2100.0,2.242147575241161],[2200.0,2.256751582973422],[2300.0,2.2680864392942484],[2400.0,2.277567110195219],[2500.0,2.2861380562233546],[2600.0,2.2939461223312194],[2700.0,2.3011072923644633],[2800.0,2.3077145568604776],[2900.0,2.3138434556974783],[3000.0,2.3195560680385148]]},{"name":"7.0 in/turn","data":[[2000.0,1.6350758514794261],[2100.0,1.6472920960955462],[2200.0,1.6580215711641462],[2300.0,1.666349220705978],[2400.0,1.6733146115719975],[2500.0,1.6796116331436886],[2600.0,1.6853481715086507],[2700.0,1.6906094392881768],[2800.0,1.6954637560607586],[2900.0,1.6999666205124322],[3000.0,1.7041636418242145]]},{"name":"8.0 in/turn","data":[[2000.0,1.2518549487889359],[2100.0,1.261208011073153],[2200.0,1.2694227654225494],[2300.0,1.2757986221030146],[2400.0,1.2811314994848109],[2500.0,1.2859526566256367],[2600.0,1.2903446938113108],[2700.0,1.2943728519550106],[2800.0,1.2980894382340185],[2900.0,1.3015369438298312],[3000.0,1.3047502882716644]]},{"name":"9.0 in/turn","data":[[2000.0,0.9891199595369371],[2100.0,0.9965100334405157],[2200.0,1.0030007035437427],[2300.0,1.0080384174641104],[2400.0,1.012252048975653],[2500.0,1.0160613583214908],[2600.0,1.0195316099249863],[2700.0,1.022714352161984],[2800.0,1.0256509141602121],[2900.0,1.028374869198879],[3000.0,1.0309138080171176]]}]
};

const dragOptions = {
  chart: {
    type: 'spline',
  },
  title: {
    text: 'Drag Coefficient'
  },
  subtitle: {
   text: '.243 Caliber Claymore - 103 gr.'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Mach Number'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Drag Coefficient'
    }
  },
  plotOptions: {
    spline: {
      marker: {enabled: true}
    }
  },
  tooltip: {
    headerFormat: "Mach {point.key:.2f}<br>",
    pointFormat: "{series.name} CD: {point.y:.2f}"
  },
  series: [{"name":"G1","data":[[0.5,0.10308299823605621],[0.6,0.10318445787998934],[0.7,0.10983006455760912],[0.8,0.12915812672686966],[0.85,0.14716721352499956],[0.9,0.17324234201581298],[0.925,0.1894251552231466],[0.95,0.2071805929114437],[0.975,0.22564624810727266],[1.0,0.2437567945493357],[1.1,0.29844354262929074],[1.2,0.3243157518322379],[1.3,0.33425879693768423],[1.4,0.3360850705284805],[1.5,0.33344711978621927],[1.6,0.3284248674115295],[1.7,0.32198218002177603],[1.8,0.3150321944123568],[2.0,0.30103076354958547],[2.2,0.2883990378799112],[2.5,0.273788849153541],[3.0,0.26039617615436833],[3.5,0.255678302711478],[4.0,0.2539534887646149],[4.5,0.2533193659900328],[5.0,0.25304035196921676]]},{"name":"G7","data":[[0.5,0.11931886891553141],[0.6,0.11931886891553141],[0.7,0.12011832532367565],[0.8,0.12411560736439699],[0.85,0.1305112586295511],[0.9,0.1463005226904003],[0.925,0.1658872046899348],[0.95,0.20526043279103975],[0.975,0.2990966286969728],[1.0,0.3800415900215795],[1.1,0.40112725278638445],[1.2,0.3881360861540401],[1.3,0.37294641439929915],[1.4,0.35775674264455815],[1.5,0.34376625550203344],[1.6,0.3312747491247794],[1.7,0.3206819517168679],[1.8,0.31148820302320884],[2.0,0.29779751203373833],[2.2,0.2862053941156465],[2.5,0.26951674159563493],[3.0,0.242235291667712],[3.5,0.21525363789284307],[4.0,0.19336851871989386],[4.5,0.1760303078682651],[5.0,0.16169005854717738]]},{"name":"Actual","data":[[0.5,0.12473941886080639],[0.6,0.12453726676221388],[0.7,0.12525274408167067],[0.8,0.12655299579712848],[0.85,0.12733887813606848],[0.9,0.13288218626481155],[0.925,0.14231819716500763],[0.95,0.1674161281306464],[0.975,0.21343850762218658],[1.0,0.3067724208311615],[1.1,0.33836864961593704],[1.2,0.34353029289294756],[1.3,0.34849726575293394],[1.4,0.3468587257518634],[1.5,0.33856036173427767],[1.6,0.3300011405942257],[1.7,0.32187728199995214],[1.8,0.31415725894544044],[2.0,0.29973953354479876],[2.2,0.28646569442731273],[2.5,0.26841303363865643],[3.0,0.24281503206439822],[3.5,0.22219310150241803],[4.0,0.20567896846161235],[4.5,0.1924021085606252],[5.0,0.18162399895371223]]}]
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <AerodynamicsCharts
      windOptions={windOptions}
      stabilityOptions={stabilityOptions}
      dragOptions={dragOptions}
     />,
    document.getElementById('clm_24_103_charts')
  );
});
